import {
  ALPHA_NUMERIC,
  NUMERIC,
  OnboardConstants,
  PlaceHolderText,
  StaffListConstants,
} from "../../constants/constants";
import Button from "./cta/Button";
import Input from "./cta/Input";
import {
  staffVerificationCancelButton,
  staffVerificationverifiedButton,
  staffVerificationverifyButton,
} from "./styles/CommonStyles";
import { TextFeild } from "./TextFeild";

export const BankVerificationDetail = ({
  userInfo,
  handleChange,
  isDetailPresent,
  handleVerifyButtonChange,
  verifyTitle,
  handelCancelButton,
  showVerifyButton,
}: any) => {
  return (
    <>
      {isDetailPresent ? (
        <div className="pl-6 md:pl-8 pt-10 grid md:grid-rows-1 md:grid-flow-col pr-6 md:pr-8 gap-5 md:pr-[292px]">
          <TextFeild
            textFeildName={StaffListConstants.BankAccountNumber}
            placeholder={userInfo?.bankDetails?.accountNumber ?? ""}
          />
          <TextFeild
            textFeildName={StaffListConstants.IFSCCode}
            placeholder={userInfo?.bankDetails?.ifscCode ?? ""}
          />
        </div>
      ) : (
        <div className="flex flex-col md:flex-row md:gap-8 px-6 md:px-0 md:pl-8">
          <div className="w-full md:w-1/2 relative">
            <Input
              type="text"
              name="accountNumber"
              value={userInfo?.bankDetails?.accountNumber ?? ""}
              placeholder={PlaceHolderText.accountNumber}
              handleOnChange={handleChange}
              label="Bank Account Number*"
              regexCode={NUMERIC}
            />
          </div>
          <div className="w-full md:w-1/2 relative">
            <Input
              type="text"
              name="ifscCode"
              value={userInfo?.bankDetails?.ifscCode ?? ""}
              placeholder={PlaceHolderText.ifscCode}
              handleOnChange={handleChange}
              label="IFSC Code*"
              allowNumber={true}
              regexCode={ALPHA_NUMERIC}
            />
          </div>
        </div>
      )}
      <div className="md:pl-8">
        <div className="flex justify-center md:justify-start items-center md:items-start">
          {!userInfo?.ekycStatus?.bank && (
            <div className="mb-6">
              <Button
                handleClick={handelCancelButton}
                buttonText={StaffListConstants.Cancel}
                className={staffVerificationCancelButton}
              />

              <Button
                handleClick={
                  showVerifyButton && !userInfo?.ekycStatus?.bank
                    ? () => handleVerifyButtonChange(verifyTitle)
                    : () => {}
                }
                buttonText={
                  !userInfo?.ekycStatus?.bank
                    ? OnboardConstants.verify
                    : OnboardConstants.verified
                }
                className={
                  !userInfo?.ekycStatus?.bank
                    ? staffVerificationverifyButton
                    : staffVerificationverifiedButton
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
